import React, { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  uploadSubTitleVideo,
  uploadVideo,
} from "../../thunks/subTitle/subTitle";
import { getFromLocal } from "../../utils/localStorage";
import Loader from "../common/Loader";
import { showToast } from "../../utils/general";
import {
  setSelectedVideo,
  setSelectedVideoUrl,
} from "../../store/AiDubbing/AiDubbingSlice";

const FileUpload = ({
  onUpload,
  maxSize = 50,
  accept = "*image/*",
  aiDubbing = false,
}) => {
  const [loader, setLoader] = useState(false);
  const [isDragActive, setIsDragActive] = useState(false);
  const dispatch = useDispatch();

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const callback = () => {
    setLoader(false);
    onUpload();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoader(true);

    setIsDragActive(false);
    const files = e.dataTransfer.files[0];
    fileUpload(files);
  };

  const fileUpload = (file) => {
    if (file && file.size > maxSize * 1024 * 1024 && !aiDubbing) {
      showToast(`Max size: ${maxSize} MB.`, "", "danger");
      setLoader(false);
      return;
    }

    if (aiDubbing) {
      if (file && file.size > maxSize * 1024 * 1024) {
        showToast(`Max size: ${maxSize} MB.`, "", "danger");
        setLoader(false);
        return;
      }
      const videoURL = URL.createObjectURL(file);
      dispatch(setSelectedVideoUrl(videoURL));
      dispatch(setSelectedVideo(file));
      setLoader(false);
      showToast(`Video Uploaded SuccessFully`);

      return;
    }

    dispatch(uploadSubTitleVideo(file, getFromLocal("userId"), callback));
  };

  const handleFileChange = (e) => {
    setLoader(true);
    const files = e.target.files[0];
    console.log("aiDubbing Files", files);
    fileUpload(files);
  };

  return (
    <div className="flex items-center justify-center">
      {!!loader && <Loader />}
      <div
        className={`w-full max-w-lg p-6 h-[248px] bg-transparent border-2 border-dashed rounded-lg flex flex-col items-center justify-center ${
          isDragActive ? "border-blue-500" : "border-gray-300"
        }`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <input
          type="file"
          className="hidden"
          id="fileUpload"
          multiple
          onChange={handleFileChange}
          accept={accept}
        />
        <label
          htmlFor="fileUpload"
          className="flex flex-col items-center cursor-pointer"
        >
          <img
            src="/tool/dashboard/static/images/fileupload.svg"
            alt="Upload Icon"
          />
          <p className="mb-2 text-gray-500">
            Drag & drop your file here or{" "}
            <span className="text-[#0049C6] underline decoration-solid">
              choose file
            </span>
          </p>

          <p className="mt-2 text-gray-400">{maxSize}MB max file size</p>
        </label>
      </div>
    </div>
  );
};

export default FileUpload;
